export const MOCK_CURRENCY_OPTIONS = [
  { label: 'EUR', value: 'EUR' },
  { label: 'GBP', value: 'GBP' },
  { label: 'USD', value: 'USD' },
  { label: 'CHF', value: 'CHF' },
]
